export enum PaymentMethodService {
  AMEX = 'amex',
  AMEX_TRANSPARENT = 'amex-transparent',
  AMERICAN_EXPRESS = 'american-express',
  DISCOVER = 'discover',
  DISCOVER_BW = 'discover-bw',
  MAESTRO = 'maestro',
  MAESTRO_BW = 'maestro-bw',
  MASTERCARD = 'master-card',
  MASTERCARD_BW = 'master-card-bw',
  VISA = 'visa',
  VISA_BW = 'visa-bw',
  PAYPAL = 'paypal',
  APPLE_PAY = 'apple-pay',
  GOOGLE_PAY = 'google-pay',
}
